<header class="o-minimal-header -primary select-none">
  @if (!this.currentNavigationItem().hideSideNavigation) {
    <nav
      #sideNavigation
      [class.-open]="sideNavigationService.isSideNavOpen()"
      [class.-width-animating]="sideNavigationService.isWidthAnimating()"
      aria-hidden="false"
      aria-label="Side Navigation"
      class="m-side-navigation -contrast"
      (mouseenter)="onSideNavigationMouseEnter()"
      (mouseleave)="onSideNavigationMouseLeave()"
    >
      <div class="m-side-navigation__header">
        <div class="flex">
          @if (sideNavigationService.isSideNavOpen()) {
            <img
              src="assets/NG_Portal_Icon.svg"
              alt="NG Portal Icon"
              class="ng-portal-icon"
              width="50"
              height="50"
            />
          }

          <div class="m-side-navigation__header__label -size-l highlight">NG Portal</div>
        </div>

        <button
          (click)="toggleSideNav()"
          aria-haspopup="false"
          aria-label="Open Side Navigation"
          class="a-button a-button--integrated -without-label m-side-navigation__header__trigger -open"
          tabindex="0"
          type="button"
        >
          <i
            class="a-icon a-button__icon boschicon-bosch-ic-list-view-mobile"
            title="Open Side Navigation"
          ></i>
        </button>
        <button
          (click)="toggleSideNav()"
          aria-haspopup="false"
          aria-label="Close Side Navigation"
          class="a-button a-button--integrated -without-label m-side-navigation__header__trigger -close"
          tabindex="-1"
          type="button"
        >
          <i
            class="a-icon a-button__icon boschicon-bosch-ic-close"
            title="Close Side Navigation"
          ></i>
        </button>
      </div>
      <div class="sidemenu-wrapper flex flex-col justify-between">
        <div>
          <ul class="m-side-navigation__menuItems" role="menubar">
            @for (navigationItem of navigationItems.getSideNavItems(); track navigationItem) {
              <side-navigation-item
                [name]="navigationItem.name"
                [navigationItem]="navigationItem"
              ></side-navigation-item>
            }
            <side-navigation-item
              [name]="userService.getUser().displayName"
              [navigationItem]="navigationItems.getProfilePage()"
            ></side-navigation-item>
          </ul>
        </div>

        <navigate-footer></navigate-footer>
      </div>
    </nav>
  }

  <div #supergraphic class="o-minimal-header__supergraphic"></div>

  <div #headerTop class="o-minimal-header__top">
    @if (!this.currentNavigationItem().hideSideNavigation) {
      <div class="o-minimal-header__burger">
        <button
          (click)="toggleSideNav()"
          aria-label="Side Navigation"
          class="a-button a-button--integrated -without-label"
          type="button"
        >
          <i class="a-icon a-button__icon ui-ic-menu" title="Side Navigation"></i>
        </button>
      </div>
    }

    <div
      [ngClass]="{ 'title-container': sideNavigationService.isSideNavOpen() }"
      class="o-minimal-header__title"
    >
      {{ this.currentNavigationItem().name }}
    </div>
    <ul class="o-minimal-header__actions">
      <li>
        <ide-client />
      </li>
      <li class="w-[300px]">
        @if (currentNavigationOnStartPage()) {
          <start-page-search-bar [isMinimal]="false" />
        }
      </li>
    </ul>
    <a
      [routerLink]="navigationItems.getStartPage().routerLink"
      aria-label="Bosch Logo"
      class="o-minimal-header__logo"
    >
      <bosch-logo></bosch-logo>
    </a>
    <div class="o-minimal-header__falafel">
      @if (currentNavigationOnStartPage()) {
        <start-page-search-bar [isMinimal]="true" />
      }
    </div>
  </div>
</header>
